import { get } from 'lodash'

import { getDefaultHeaders } from './getDefaultHeaders'

const defaultHeaders = getDefaultHeaders()

export default defaultHeaders
export const testbearer = get(global, 'bearertoken')
